var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"causa-baixo-desempenho","rota-base":"/admin/causa-baixo-desempenho","titulo-singular":"Causa de Baixo Desempenho","campos-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }